export default __webpack_public_path__ + "static/media/Federico_Wiesner.6ca5595a.png";